var map = {
	"./angular.png": 38,
	"./angular_material.jpeg": 39,
	"./angularjs.jpeg": 40,
	"./angularjs.png": 41,
	"./aspire.png": 42,
	"./cognizant.png": 43,
	"./copilot.jpeg": 44,
	"./css.png": 45,
	"./down-arrow.png": 21,
	"./down.png": 46,
	"./google.png": 47,
	"./graphql.png": 48,
	"./grunt.png": 49,
	"./gulp.png": 50,
	"./ham-icon.png": 22,
	"./hcl.png": 51,
	"./home.jpg": 52,
	"./home_1.jpg": 53,
	"./html.png": 54,
	"./java.png": 55,
	"./jquery.png": 56,
	"./js.png": 57,
	"./mongo.png": 58,
	"./mysql.png": 59,
	"./nest.png": 60,
	"./node.png": 61,
	"./optum.png": 62,
	"./oracle.png": 63,
	"./profile.jpeg": 23,
	"./react.png": 64,
	"./scala.png": 65,
	"./sql.png": 66,
	"./up.png": 24,
	"./v3.png": 67
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17;